const lockTimerThreshold = 3000;

const lockTimerKey = "galleryKey";

export const lockTab = (): boolean => {
    let delta = 0;
    try {
        const msSinceEpoch = parseInt(localStorage.getItem(lockTimerKey) || "0");
        const actualMsSinceEpoc = timeSinceEpoch();
        delta = actualMsSinceEpoc - msSinceEpoch;
    } catch (error) {
        console.log(error);
        delta = 0;
    }
    if (delta < lockTimerThreshold) {
        console.log("Page is locked by another tab, sorry!")
        return false;
    }

    // While this page is open, keep the lock running.
    setInterval(() => {
        const now = timeSinceEpoch();
        localStorage.setItem(lockTimerKey, `${now}`);
    }, lockTimerThreshold / 4);
    return true;
};

const timeSinceEpoch = () => {
    return Math.round((new Date()).getTime());
};
